import React, { useState } from 'react';

//CSS
import useStyles from './styles';

//Components
import Searchbox from '../../../components/inputs/searchbox';
import Autocomplete from '../../../components/inputs/Autocomplete';
import Dropdown from '../../../components/inputs/dropdown';


//Material UI
import { Paper, Typography, Grid, Tooltip, Chip, Button } from '@mui/material';
import { createFilterOptions } from '@mui/material/Autocomplete';
import FilterListIcon from '@mui/icons-material/FilterList';

//Hooks
import useCategories from '../../../hooks/category/useCategories';

const stockFiltersValues = [
    { id: 0, label: 'Todos los productos', action: { lessOrEqualTo: null, moreOrEqualTo: null } },
    { id: 1, label: 'Sin stock', action: { lessOrEqualTo: '0', moreOrEqualTo: '0' } },
    { id: 2, label: 'Con stock', action: { lessOrEqualTo: null, moreOrEqualTo: '1' } },
    { id: 3, label: 'Con stock negativo', action: { lessOrEqualTo: '1', moreOrEqualTo: null } },
]

const Filters = ({ filters, setFilters, setFilterCategories, clearFilters }) => {
    const { classes } = useStyles();
    const { categories, loading, findChildren, GetPath, ChangeTextFilter } = useCategories();
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [selectedStockFilter, setSelectedStockFilter] = useState();

    const handleSkusChange = (event) =>
        setFilters({ [event.target.name]: event.target.value });

    const handleDescriptionChange = (event) =>
        setFilters({ [event.target.name]: event.target.value });

    const handleCategoryAutocompleteInputChange = (event, value) => {
        if (!!value.length && value.length > 2) ChangeTextFilter(value);
    }

    const handleCategoryAutocompleteChange = async (event, options, action, arg) => {
        if (action === "select-option") {
            arg.option.children = await findChildren(arg.option);
        }

        setSelectedCategories(options.map(s => s));
        setFilterCategories(buildCategoryIds(options));
    }

    const buildCategoryIds = (categories) => {
        const hash = {};
        categories.forEach(i => {
            hash[i.id] = i.id;
        });

        return Object.keys(hash).map(Number);
    }

    const handleClearFilters = () => {
        setSelectedCategories([]);
        setSelectedStockFilter();

        setFilterCategories([])
        clearFilters();
    }

    const handleDropdownChange = (event) => {
        setSelectedStockFilter(event.target.value);

        setFilters({ ...stockFiltersValues[event.target.value].action });
    }

    return (
        <Paper className={classes.paperFullWidth}>
            <Grid container spacing={1}>
                <Grid size={12}>
                    <Grid container spacing={1}>
                        <Grid size={12}>
                            <Typography variant='inherit' color='primary'> Filtrar por producto </Typography>
                        </Grid>

                        <Grid
                            size={{
                                xs: 12,
                                md: 3
                            }}
                        >
                            <Searchbox
                                fullWidth
                                size='small'
                                name='refId'
                                label="Codigo de producto"
                                helperText="Empiece a escribir el codigo para buscar"
                                onChange={handleSkusChange}
                                className={classes.searchbox}
                                value={filters?.refId || ''}
                            />
                        </Grid>

                        <Grid
                            size={{
                                xs: 12,
                                md: 2
                            }}
                        >
                            <Searchbox
                                fullWidth
                                size='small'
                                name="color"
                                label="Color"
                                helperText="Escribir el color"
                                onChange={handleDescriptionChange}
                                className={classes.searchbox}
                                value={filters?.color || ''}
                            />
                        </Grid>
                        <Grid
                            size={{
                                xs: 12,
                                md: 5
                            }}
                        >
                            <Searchbox
                                fullWidth
                                size='small'
                                name="textFilter"
                                label="Descripción"
                                helperText="Descripción larga del producto"
                                onChange={handleDescriptionChange}
                                className={classes.searchbox}
                                value={filters?.textFilter || ''}
                            />
                        </Grid>
                        <Grid
                            size={{
                                xs: 12,
                                md: 2
                            }}
                        >
                            <Dropdown
                                fullWidth
                                size='small'
                                name='documentType'
                                label='Stock'
                                getOptionValue={(option) => option?.id}
                                onChange={handleDropdownChange}
                                value={selectedStockFilter || ''}
                                values={stockFiltersValues}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid
                    size={{
                        xs: 12,
                        md: 12
                    }}
                >
                    <Grid container spacing={1} alignItems="flex-end">
                        <Grid
                            size={{
                                xs: 12,
                                md: 3
                            }}
                        >
                            <Grid container spacing={1}>
                                <Grid size={12}>
                                    <Typography variant='inherit' color='primary'> Filtrar por Master ID: </Typography>
                                </Grid>
                                <Grid size={12}>
                                    <Searchbox
                                        fullWidth
                                        size='small'
                                        name='masterProductId'
                                        label="Master ID de producto"
                                        onChange={handleSkusChange}
                                        className={classes.searchbox}
                                        value={filters?.masterProductId || ''}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid
                            size={{
                                xs: 12,
                                md: 6
                            }}
                        >
                            <Grid container spacing={1}>
                                <Grid size={12}>
                                    <Typography variant='inherit' color='primary'>Filtrar por categorías:</Typography>
                                </Grid>
                                <Grid size={12}>
                                    <Autocomplete
                                        fullWidth
                                        multiple
                                        size='small'
                                        options={categories}
                                        loading={loading}
                                        loadingText='Buscando categorías...'
                                        value={selectedCategories}
                                        getOptionLabel={(option) => option.description}
                                        onInputChange={handleCategoryAutocompleteInputChange}
                                        onChange={handleCategoryAutocompleteChange}
                                        TextProps={{
                                            label: '',
                                            placeholder: 'Ej.: Dormitorio',
                                        }}
                                        filterOptions={createFilterOptions({
                                            stringify: (option) => option.description + option.path,
                                        })}
                                        renderOption={(props, option) => (
                                            <li {...props}>
                                                <span>{option.path}</span>
                                            </li>
                                        )}
                                        renderTags={(value, getTagProps) =>
                                            value.map((option, index) => (
                                                <Tooltip key={index} title={GetPath(option)}>
                                                    <Chip label={option.description} {...getTagProps({ index })} />
                                                </Tooltip>
                                            ))
                                        }
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid
                            size={{
                                xs: 12,
                                md: 3
                            }}
                            container
                            alignItems="flex-end"
                            justifyContent="flex-end"
                        >
                            <Button
                                color="primary"
                                variant="outlined"
                                onClick={handleClearFilters}
                                startIcon={<FilterListIcon />}
                            >
                                Limpiar
                            </Button>
                        </Grid>


                    </Grid>
                </Grid>
            </Grid>
        </Paper>
    );
}

export default Filters;